import HTTP from '@/utils/http'
/**
 * 
 * @param {*} params 
 */


//  首页banner数据
export const getBanner = (params) => HTTP("/api/v2/ad/index",params,false,)

// 通知公告,文章列表
export const getInform = (params) => HTTP("/api/v2/article/articleList",params,true,)

// 获取配置文件
export const getJsApiConf= (params) => HTTP("/api/user/getJsApiConf",params,false,)


// 首页统计数据
export const getHomeCount= (params) => HTTP("/api/v2/work/count",params,false,)


// export const getTest3 = function(params){
//     return HTTP('/api/community/getCommunitylist', params)
// }